// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"map-cursor-with-text_wrapper__5JBsa"};